<template>

  <div class="assignee-select dropdown">
    <button
      type="button"
      class="btn btn-outline-secondary dropdown-toggle"
      :disabled="saving"
      @click="toggle">
      <i
        v-if="saving"
        class="fa-solid fa-circle-notch fa-spin mr-1"></i>
      <i
        v-else
        class="fa-solid fa-user-tag mr-1"></i>
      <span class="hide-less-sm">{{ selectedLabel }}</span>
    </button>

    <div
      v-if="open"
      class="dropdown-menu dropdown-menu-right show assignee-menu">

      <div class="assignee-search px-2 pb-2">
        <input
          ref="search"
          v-model="query"
          type="text"
          class="form-control form-control-sm"
          :placeholder="$t('Search user')">
      </div>

      <a
        href="javascript:void(0)"
        class="dropdown-item"
        :class="{ active: !value }"
        @click="choose(null)">
        {{ $t('Unassigned') }}
      </a>

      <a
        v-for="option in filteredUsers"
        :key="option.id"
        href="javascript:void(0)"
        class="dropdown-item text-truncate"
        :class="{ active: option.id === value }"
        @click="choose(option.id)">
        {{ option.name }}
      </a>

      <div
        v-if="!filteredUsers.length"
        class="dropdown-item-text text-muted small">
        {{ $t('No users found') }}
      </div>

    </div>

    <div
      v-if="open"
      class="assignee-backdrop"
      @click="close"></div>

  </div>

</template>

<script>
export default {
  name: 'ConversationAssigneeSelect',
  props: {
    users: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: null
    },
    saving: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      open: false,
      query: ''
    }
  },
  computed: {
    // normalize members ({ user_id: {...} }) into { id, name } options
    options () {
      return this.users
      .map((member) => {
        const user = member.user_id || {}
        const id = typeof user === 'object' ? user._id : user
        return {
          id: id,
          name: (typeof user === 'object' ? user.name : null) || member.name || id
        }
      })
      .filter((option) => { return !!option.id })
    },
    filteredUsers () {
      const query = this.query.trim().toLowerCase()
      if (!query) {
        return this.options
      }
      return this.options.filter((option) => {
        return (option.name || '').toLowerCase().includes(query)
      })
    },
    selectedLabel () {
      if (!this.value) {
        return this.$t('Unassigned')
      }
      const found = this.options.find((option) => { return option.id === this.value })
      return found ? found.name : this.$t('Assigned')
    }
  },
  methods: {
    toggle () {
      this.open = !this.open
      if (this.open) {
        this.query = ''
        this.$nextTick(() => {
          if (this.$refs.search) {
            this.$refs.search.focus()
          }
        })
      }
    },
    close () {
      this.open = false
    },
    choose (id) {
      this.close()
      if (id !== this.value) {
        this.$emit('input', id)
      }
    }
  }
}
</script>

<style scoped>
/* the .dropdown class already handles positioning; these cover what
   Bootstrap utilities can't: a scrollable menu, a sticky search box and a
   full-screen backdrop to close the menu on outside click */
.assignee-menu {
  display: block;
  max-height: 320px;
  overflow-y: auto;
  min-width: 220px;
  z-index: 1050;
}

.assignee-search {
  position: sticky;
  top: 0;
  background: #fff;
  padding-top: 8px;
}

.assignee-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1040;
}
</style>



// WEBPACK FOOTER //
// src/components/Messaging/conversation/ConversationAssigneeSelect.vue